import { useMemo } from 'react';
import useSWR from 'swr';

export function useCaptchaStatus(captchaType = "login") {
  const captchaLoginProp = useSWR("/captcha/" + captchaType);
  const hasCaptcha = useMemo(() => {
    if (captchaLoginProp.isLoading) {
      return null;
    }
    return captchaLoginProp.data?.data;
  }, [captchaLoginProp.isLoading]);

  return hasCaptcha;
}
